import { CustomRoutes, localStorageStore, Admin as ReactAdmin } from 'react-admin'
import { Route } from 'react-router-dom'
import Layout from '../layout/Layout'
import { theme as xxTheme } from '../layout/themes'
import LoginPage from '../pages/Login'
import Unauthorized from '../pages/Unauthorized'
import providers from '../providers'
import { Permissions } from '../types/apiTypes'
import { resourcesForScopes } from './Resources'
import { FC, ReactElement } from 'react'

const store = localStorageStore()

const Admin: FC = () => (
  <ReactAdmin
    i18nProvider={providers.i18n}
    authProvider={providers.auth()}
    dataProvider={providers.data}
    layout={Layout}
    loginPage={LoginPage}
    disableTelemetry
    theme={xxTheme}
    store={store}
    // eventueel: basename="/app" als je niet op /
  >
    {(permissions: Permissions): ReactElement[] => resourcesForScopes(permissions)}

    <CustomRoutes>
      <Route path="/unauthorized" element={<Unauthorized />} />
    </CustomRoutes>
  </ReactAdmin>
)

export default Admin
